export var BillingStatus;
(function (BillingStatus) {
    BillingStatus["ForPayment"] = "for_payment";
    BillingStatus["PaymentSubmitted"] = "payment_submitted";
    BillingStatus["Paid"] = "paid";
})(BillingStatus || (BillingStatus = {}));
